import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M20.71 4.5H3A1.5 1.5 0 0 0 1.5 6v11.25a2.25 2.25 0 0 0 2.25 2.25h16.5a2.25 2.25 0 0 0 2.25-2.25V6A1.5 1.5 0 0 0 21 4.5h-.29Zm-10.3 10.72a2.25 2.25 0 0 0 3.182 0L21 7.81v9.44a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1-.75-.75V7.81l7.409 7.41ZM3.311 6h17.378l-8.159 8.16a.75.75 0 0 1-1.06 0L3.31 6Z" }));
export {
  a as default
};
//# sourceMappingURL=newsletter-icon-DYTFgi3S.js.map
